var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutomationBuilderModal',_vm._g(_vm._b({attrs:{"items":_vm.decisions,"title":_vm.__('Escolha a decisão'),"button":_vm.__('Escolher decisão')},on:{"input":_vm.handleInput}},'AutomationBuilderModal',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }